import { Client } from '@/utils';
import { password } from '@/api';

const GET_CODE = 'password/CODE';
const CHANGE_POSSWORD = 'password/CHANGEPOSSWORD';

export default {
  state: {
  },
  actions: {
    async [GET_CODE]({ commit }, { params = {}, frontCode = '' } = {}) {
      const value = await Client.get(password.getcode, { params }, frontCode,false,true,true)
      return value
    },
    async [CHANGE_POSSWORD]({ commit }, { data = {}, frontCode = '' } = {}) {
      commit(CHANGE_POSSWORD, await Client.post(password.changepwd, { data }, frontCode,true,false,true));
    },
  },
  /* eslint-disable no-param-reassign */
  mutations: {
    [GET_CODE]() {},
    [CHANGE_POSSWORD]() {},
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/password.js